import { SDKResponse } from '@commercetools/frontend-sdk';
import useSWR from 'swr';
import { sdk } from 'sdk';
import { ProjectSettings } from 'shared/types/ProjectSettings';

const useProjectSettings = () => {
  const response = useSWR<SDKResponse<ProjectSettings>>('action/project/getProjectSettings', () =>
    sdk.callAction<ProjectSettings>({ actionName: 'project/getProjectSettings' }),
  );

  const data = response.data?.isError ? ({} as ProjectSettings) : (response.data?.data as ProjectSettings);

  return { ...response, data };
};

export default useProjectSettings;
